import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";

export default function MeshSeriesSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const sessionId = params.get("session_id");
  const [order, setOrder] = useState(null);
  const [pollDone, setPollDone] = useState(false);

  useEffect(() => {
    if (!orderId) return;
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      try {
        if (sessionId) {
          await api.get(`/checkout/status/${sessionId}`);
        }
        const r = await api.get(`/mesh-series/order/${orderId}`);
        if (cancelled) return;
        setOrder(r.data);
        if (r.data.payment_status === "paid" || attempts >= 6) {
          setPollDone(true);
          // Fire GA purchase event once we confirm payment
          if (r.data.payment_status === "paid" && window.gtag) {
            window.gtag("event", "purchase", {
              transaction_id: r.data.order_number,
              value: r.data.amount_charged,
              currency: "USD",
              items: [{ item_id: `mesh_${r.data.finish}`, item_name: `Mesh ${r.data.finish_label}`, price: r.data.amount_charged, quantity: 1 }],
            });
          }
          return;
        }
        attempts += 1;
        setTimeout(poll, 2000);
      } catch (e) {
        if (!cancelled) setPollDone(true);
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [orderId, sessionId]);

  return (
    <div className="bg-ink text-white min-h-screen pt-32 pb-24" data-testid="mesh-success-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-mono text-[11px] uppercase tracking-[0.4em] text-adrenaline">Order Received</div>
        <h1 className="text-display text-5xl md:text-7xl uppercase leading-none mt-2">Build Confirmed</h1>
        <div className="section-divider my-8" />
        {!order && !pollDone && <div className="text-zinc-400">Confirming payment…</div>}
        {order && (
          <div className="bg-carbon border border-white/10 p-8 space-y-5" data-testid="mesh-success-summary">
            <div className="flex justify-between items-baseline">
              <div>
                <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Order Number</div>
                <div className="text-display text-3xl">{order.order_number}</div>
              </div>
              <div className="text-right">
                <div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Payment Status</div>
                <div className={`text-mono uppercase tracking-wider ${order.payment_status === "paid" ? "text-adrenaline" : "text-zinc-300"}`}>
                  {order.payment_status}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div><div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Finish</div><div className="text-white">{order.finish_label}</div></div>
              <div><div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Quantity</div><div className="text-white">{order.quantity} {order.quantity === 1 ? "wheel" : "wheels"}{order.quantity === 4 ? " (Full Set)" : ""}</div></div>
              <div><div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Price Per Wheel</div><div className="text-white text-display text-xl">${order.price_per_wheel?.toLocaleString()}</div></div>
              <div><div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Total Paid</div><div className="text-adrenaline text-display text-2xl">${order.amount_charged?.toLocaleString()}</div></div>
              <div><div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Vehicle</div><div className="text-white">{order.fitment?.year} {order.fitment?.make} {order.fitment?.model}</div></div>
              <div><div className="text-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Production Status</div><div className="text-white">{order.production_status}</div></div>
            </div>
            <div className="border-t border-white/10 pt-5">
              <p className="text-zinc-300 leading-relaxed">A Lone Star Speed fitment specialist will review your build before production begins. We'll email you with confirmation and any clearance recommendations within 2 business days.</p>
              <p className="text-zinc-500 text-sm mt-3">A Stripe receipt has been sent to your email.</p>
            </div>
          </div>
        )}
        <div className="mt-10">
          <Link to="/" className="text-mono text-xs uppercase tracking-[0.3em] px-8 py-3 border border-white/20 hover:border-white inline-block transition-colors" data-testid="mesh-success-home">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
